import { render } from "./ProjectCards.vue?vue&type=template&id=64296984&scoped=true"
import script from "./ProjectCards.vue?vue&type=script&lang=js"
export * from "./ProjectCards.vue?vue&type=script&lang=js"

import "./ProjectCards.vue?vue&type=style&index=0&id=64296984&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64296984"]])

export default __exports__